import { connect, ConnectedComponent } from "react-redux";
import { IStore } from "../../DataTypes/storeTypes";
import { editCreditCard, setIdempotencyKeyAction } from "../../Actions/stripeActions";
import { IProps } from "../../../../Common/Stripe/types";
import { CreditCardForm } from "../../../../Common/Stripe/CreditCardForm";

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        showEditable: !state.stripe.cardInfo || state.stripe.isCreditCardEdit,
        cardInfo: state.stripe.cardInfo,
        cdnHost: state.initialSettings.cdnHost,
        isConsentRequired: true,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        editCreditCard: () => {
            dispatch(editCreditCard(true));
        },
        onDataChanged: () => {
            dispatch(setIdempotencyKeyAction(null));
        },
        onWillUnmount: () => {
            dispatch(setIdempotencyKeyAction(null));
        },
    };
};

export const CreditCardFormConnected: ConnectedComponent<typeof CreditCardForm, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreditCardForm);
